import React from "react";
import './Switch.css'
interface SwitchProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  checked?: boolean|string|number;
  disabled?: boolean;
  onCheckedChange?: (checked: boolean) => void;
}

export const Switch = React.forwardRef<HTMLButtonElement, SwitchProps>(
  (
    {
      checked = false,
      disabled = false,
      onClick,
      onCheckedChange,
      className = "",
      ...props
    },
    ref
  ) => {
    const handleToggle = (e: React.MouseEvent<HTMLButtonElement>) => {
      if (disabled) return;

      // toggle boolean
      const newValue = !checked;

      // fire Radix-like callback
      if (onCheckedChange) onCheckedChange(newValue);

      // still allow onClick if the parent uses it
      if (onClick) onClick(e);
    };

    return (
      <button
        ref={ref}
        type="button"
        role="switch"
        aria-checked={Boolean(checked)}
        disabled={disabled}
        onClick={handleToggle}
        className={
          `switch-base
           ${disabled ? "not-allowed" : "allowed"}
           ${checked ? "primary" : "yeyeye"}
           ${className}`
        }
        {...props}
      >
        <span
          className={
            `span-content
             ${checked ? "translate-content" : "translate-zero"}`
          }
        />
      </button>
    );
  }
);